import React from 'react'
import { Layout, Button, Dropdown, Avatar, Space, Typography } from 'antd'
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UserOutlined,
    LogoutOutlined,
    SettingOutlined,
    BellOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/hooks/useAuth'
import { PlatformStatusPill } from './PlatformStatusPill'

const { Header: AntHeader } = Layout
const { Text } = Typography

interface HeaderProps {
    collapsed: boolean
    onToggle: () => void
}

export const Header: React.FC<HeaderProps> = ({ collapsed, onToggle }) => {
    const navigate = useNavigate()
    const { user, logout } = useAuth()

    const handleLogout = async () => {
        await logout()
        navigate('/login')
    }

    const userMenuItems: MenuProps['items'] = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'Profile',
            onClick: () => navigate('/profile'),
        },
        {
            key: 'settings',
            icon: <SettingOutlined />,
            label: 'Settings',
            onClick: () => navigate('/settings'),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
            danger: true,
            onClick: handleLogout,
        },
    ]

    return (
        <AntHeader
            style={{
                padding: '0 24px',
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #f0f0f0',
                position: 'sticky',
                top: 0,
                zIndex: 1,
            }}
        >
            <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={onToggle}
                style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                }}
            />

            <Space size="large">
                <PlatformStatusPill />

                <Button
                    type="text"
                    icon={<BellOutlined />}
                    style={{ fontSize: '18px' }}
                />

                <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                    <Space style={{ cursor: 'pointer' }}>
                        <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#7c3aed' }} />
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Text strong>{user?.name || 'Admin'}</Text>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {user?.role || 'Administrator'}
                            </Text>
                        </div>
                    </Space>
                </Dropdown>
            </Space>
        </AntHeader>
    )
}

